/* eslint-disable react/no-array-index-key */
import { FC } from "react";
import Skeleton from "react-loading-skeleton";

import { PropsWithClasses } from "web/types/Common";

import classify from "web/classify";

import defaultClasses from "./breadcrumbs.scss";

const SkeletonBreadcrumbs: FC<PropsWithClasses> = ({ classes = {} }) => {
  return (
    <div className={classes.list}>
      {Array(3)
        .fill(undefined)
        .map((item, index) => (
          <Skeleton className={classes.item} key={index} />
        ))}
    </div>
  );
};

export default classify<PropsWithClasses>(defaultClasses)(SkeletonBreadcrumbs);
